import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormArray } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import {  BehaviorSubject, Subscription } from 'rxjs';
import { AmazonServices, product } from 'src/app/services/AmazonServices';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { CustomTreeService } from 'src/app/system-utils/custom-tree-view/custom-tree-view.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

export const SuperRequired = ['SKU','StandardProductID','Condition','DescriptionData','Title','Brand','BulletPoint','Manufacturer','Description',
'MfrPartNumber','IsDiscontinuedByManufacturer','RecommendedBrowseNode','ProductData','ProductType','VariationData','ItemDimensions']
/*export interface product{
    columnName?:string,
    type?:string,
    required?:boolean,
    enum?:string[],
    child?:product[];
    minLength?:number;
    maxLength?:number;
    isattribute:boolean;
    isopen?:boolean;
    level?:number;
    multi:boolean,
    isvisible
}*/

@Component({
    selector: 'criacao-produto',
    templateUrl: './criacao-produto.component.html',
    styleUrls: ['./criacao-produto.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CriacaoProdutoComponent implements OnInit {

  searchValue;
  sub:Subscription;
  sub1:Subscription;
  sub2:Subscription;
  @Input('productData')productData:string = 'none';
  @Input('columnNamePar')colunNamePar:string = 'SKU,StandardProductID';
  @Input('formGroup') formGroup1:UntypedFormGroup = this.fb.group({});
  @Input('geralGroup') geralGroup:UntypedFormGroup;
  @Input('info') info:Object;
  @Input('treename') treename:string; 
  @Input('userConfig') userConfig:Object = {}; 

  public listSync:BehaviorSubject<product[]> = new BehaviorSubject<product[]>([]);
  public listSyncTemp:BehaviorSubject<product[]> = new BehaviorSubject<product[]>([]);
  public list:product[] = [];
  products:product[] = [];
  amazonSchema  = {}
  mainRequired:string[] = [];
  currentFormGroup:UntypedFormGroup;
  showAll = true;
  showFather;
  paths: {PATH:string, INTERNALID:number}[] = [];
  amazonSubscription:Subscription;
  selectedLine:product;
  currentPath: string;
  canSave = false;

  constructor(private http:HTTPService, private fb:UntypedFormBuilder, private cd:ChangeDetectorRef,@Inject(AmazonServices) private AmazonServices:AmazonServices,
  private spinner:NgxSpinnerService,public dynamicServices: DynamicFormsService, 
  public cts:CustomTreeService,private uas:UserAuthenticationServices) { 
      this.formGroup1 = fb.group({});
      this.currentFormGroup= this.formGroup1;
      
  }

  ngOnDestroy(): void {
    this.cd.detach(); 
    if (this.amazonSubscription!= null ) {this.amazonSubscription.unsubscribe();}
    if ( this.sub != null ){this.sub.unsubscribe();}
    if ( this.sub1 != null ){this.sub1.unsubscribe();}
    if ( this.sub2 != null ){this.sub2.unsubscribe();}
  }


  add(){
      
      
  }

  recursive(productdata:string,columnNamePar:string,product?:product, array?:product[]):product{

    this.mainRequired = this.amazonSchema['definitions']['.Product']['required'];

    Object.keys(this.amazonSchema['definitions']['.Product']['properties']).forEach(key=>{


      let mainOb = this.amazonSchema['definitions']['.Product']['properties'][key];

      let columnName = key; 
      
      let isRequired = false;//required.indexOf(key) > 0;
  
      
      if (  this.mainRequired.indexOf(columnName)>-1 || SuperRequired.indexOf(columnName) >-1){
        isRequired = true; 
      }


      if ( columnName != "#"){
        
        if ( columnNamePar=="ProductData" && columnName == "ProductData" ){
          let productNew:product = {
              columnName: columnName,
              child:[],
              level:0,
              isattribute:false,
              required: false,//isRequired,
              isopen: false,
              multi:false,
              isvisible: true
          }

          mainOb = this.amazonSchema['definitions']['.Product']['properties']['ProductData']['properties'][productdata];
          
          this.products.push(this.getProp(      1,
                                                productdata,
                                                mainOb,null,productNew
                                                ,productdata
                                                 ) );
          
        }else{
          if ( columnName == columnNamePar){
            let productNew:product = {
              columnName: columnName,
              child:[],
              level: 0,
              isattribute:false,
              required: false, //isRequired,
              isopen: false,
              multi:false,
              isvisible: true
            }

            this.products.push(this.getProp(      1,
                                                  productdata,
                                                  mainOb,null,productNew
                                                  ,columnName
                                                   ) );
          }
        }
          
      }
    });
    
    return  product;
  }

  hasRef(mainOb:object):boolean{
    return Object.keys(mainOb).findIndex(x=>x=="$ref")>-1
  }

  hasAny(mainOb:object):boolean{
    return Object.keys(mainOb).findIndex(x=>x=="anyOf")>-1
  }

  hasProp(obRef:object):boolean{
    return Object.keys(obRef).findIndex(x=>x=="properties")>-1;
  }

  hasEnum(obRef:object):boolean{
    return Object.keys(obRef).findIndex(x=>x=="enum")>-1;
  }

  
  hasMinimum(obRef:object):boolean{
    return Object.keys(obRef).findIndex(x=>x=="minLength")>-1;
  }

  hasMaximum(obRef:object):boolean{
    return Object.keys(obRef).findIndex(x=>x=="maxLength")>-1;
  }

  hasType(obRef:object):boolean{
    return Object.keys(obRef).findIndex(x=>x=="type")>-1;
  }

  hasRequired(obRef:object):boolean{
    if ( !ObjectUtil.isNotEmpty(obRef)){
      return false;
    }
    return Object.keys(obRef).findIndex(x=>x=="required")>-1;
  }

  enableAll(item:product[]){

    item.forEach(d=>{
      if ( d.child && d.child.length >0){
        this.enableAll(d.child)
      }
      d.isvisible =true;
      d.isopen = false;
    })

  }

  doInit(refresh:boolean = false){

    if ( refresh ){
        this.list = [];
        this.listSync = new BehaviorSubject([]);
        this.listSyncTemp= new BehaviorSubject([]);
        
    }

    if ( this.colunNamePar != null){

        if ( !refresh ){
          if ( this.userConfig && this.userConfig['CONFIG']){
            try{
              let data:product[] = JSON.parse(this.userConfig['CONFIG'])[this.colunNamePar];
              if ( ObjectUtil.isNotEmpty(data)){
                
                this.list =  data;
                for ( var col of this.colunNamePar.split(',')){
                  this.refreshForm(this.list,this.formGroup1,col);
              
                  if ( this.info != null ){
                    this.loadForm(this.formGroup1,this.info,'')
                  }    
                }
                
           
                this.listSync.next(this.list);
                this.listSyncTemp.next(this.list);
  
                this.cd.detectChanges();
                return;
              }
            }catch(Exception){

            }
            
          }
        }
        

        this.amazonSubscription = this.AmazonServices.getAmazonData().subscribe(data => {
          if (data) {
            this.products = data;
            
            for ( var col of this.colunNamePar.split(',')){

              if ( this.productData!= 'none'){
                let pd:product = this.products[0].child.find(data=>data.columnName == "ProductData");
                
                let child:product = pd.child.find(d=>d.columnName == this.productData);
                let newPath = this.paths.filter(p=>p.PATH.startsWith(this.productData));
                //let filterdChild = Object.assign([],child);
                try{
                  this.filterPath(child,newPath,this.productData);
                }catch(e){
  
                }
                
                pd.isopen = false;
                pd.isvisible = true;
                pd.child = [];
                pd.child.push(child);
                this.list.push(pd);
  
              }else{
                let prod = this.products[0].child.find(data=>data.columnName.toUpperCase()==col.toUpperCase());
                this.list.push(prod);
              }
              
              this.refreshForm(this.list,this.formGroup1,col);
            
              if ( this.info != null ){
                this.loadForm(this.formGroup1,this.info,'')
              }    
            }
            
          } else {
            this.products = [];
          }
          
          this.listSync.next(this.list);
          this.listSyncTemp.next(this.list);

          this.cd.detectChanges();

          if ( refresh ){
            this.enableAll(this.list);
            this.saveUserConfig();
            this.cd.detectChanges();
          }
        });
    }
  }
  filterPath(child: product, newPath: { PATH: string; INTERNALID: number; }[], p:string) {

      for (var i = child.child.length - 1; i > -1; i--) {
        let val = child.child[i];
        p = p+"/"+val.columnName;
      
        if ( val.child.length>0){
          this.filterPath(val,newPath,p);
        }

        let filtered = this.paths.filter(field => field.PATH == p || (field.PATH.indexOf("/*")>=0 &&  p.startsWith(field.PATH.replace("/*","")))  );
        
        if ( filtered.length == 0){
          child.child.splice(i,1);
        }
        p = p.replace('/'+val.columnName,'');
      }
      
  }

  saveUserConfig(){
      
      let config = JSON.parse(this.userConfig['CONFIG']);

      if ( config == null){
        config = {};
      }

      config[this.colunNamePar] = this.listSync.getValue();
      
      let jsonSave:Object = {
        "entityName":"Mktpusercfg",
        "IDUSER": this.uas.user.iduser,
        "IDINSTANCE":2,
        "CONFIG": JSON.stringify(config),
      }
      
      this.sub1 = this.http.post(jsonSave,"JsonBrokerServices/save",false).subscribe(me=>{
          
      });
  }
  
  ngOnInit() {

    this.sub2 = this.cts.doSave.subscribe(data=>{
      
        if ( data ){
          this.saveUserConfig();
        }
    });

    this.sub = this.cts.selected.subscribe(data=>{

      //this.selectedLine = null;
      let event:product = data.data;
      let path = data.path;
      
      setTimeout(()=>{
      
        if ( event.child != null && event.child.length == 0){
          
          //this.selectedLine = event;

          let valor:string[] = path.split(">");
          let i = 0;
          this.currentFormGroup = this.formGroup1;
          for (var p of valor){
            if ( i > 0){
              if ( this.currentFormGroup.get(p) instanceof UntypedFormGroup){
                this.currentFormGroup  = this.currentFormGroup.get(p) as UntypedFormGroup 
              }
            }
            i++
          }
          
          this.cd.detectChanges();
        }
      },0);
    });
  

    if ( this.colunNamePar == "ProductData"){
      let ob:Object = {
        "entityName":"Mktpamazonpdpath"
      }
      
      this.spinner.show('amselect')
      this.http.post(ob, 'JsonBrokerServices/find',true,true).subscribe(pa=>{
        
        this.paths = pa['Mktpamazonpdpath'];
        this.doInit();    
        this.spinner.hide('amselect')
      },error=>{
        this.spinner.hide('amselect')
      });
    }else{
        this.doInit();   
    
    }
    
    
      
  }

  superRequired(item:product){
    if ( item != null ){
      if ( SuperRequired.indexOf(item.columnName)>-1){
        return true;
      }else{
        return false;
      }
    }
    
  }

  
  hasAttrib(p:product):boolean {

    return p.isattribute;

  }


  hasChildAttrib(child:product[] ):boolean{
    let hasChildAttrib:boolean = false;
      
      child.forEach(p=>{
          hasChildAttrib =  this.hasAttrib(p);  
          if ( hasChildAttrib){
            return;
          }
        }
      );
    return hasChildAttrib;
  }

  getGroup(group:UntypedFormGroup,item:product):UntypedFormGroup{
      
      let formControl = (group.get(item.columnName) as UntypedFormGroup)

      if ( this.hasChildAttrib(item.child)){
        formControl = (group.get(item.columnName) as UntypedFormGroup)
      }

      return formControl;
  }

  refreshForm(child:product[],formGroup:UntypedFormGroup, columName:string){

        if ( child.length > 0 ){

            child.forEach( prod =>{

              if ( prod.child.length > 0 && prod.type == null){

                    let localFormGroup = formGroup.get(columName)  instanceof UntypedFormGroup ? formGroup.get(columName) as UntypedFormGroup : null;
                    if ( localFormGroup != null ){

                        localFormGroup.addControl(prod.columnName,this.fb.group({}));
                        let newLocalFormGroup = localFormGroup.get(prod.columnName) as UntypedFormGroup;
                        this.refreshForm(prod.child,newLocalFormGroup,prod.columnName);
    
                    }else{

                        formGroup.addControl(prod.columnName,this.fb.group({}));
                        let newLocalFormGroup = formGroup.get(prod.columnName) as UntypedFormGroup;
                        this.refreshForm(prod.child,newLocalFormGroup,prod.columnName);
                    }   
              }else{

                  formGroup.addControl(prod.columnName,new UntypedFormControl(''));
               
              }

            })

        }else{
          formGroup.addControl(columName,new UntypedFormControl(''));
        }
  }


  getProp(
          level:number,
          productdata:string,
          val:object,
          obRef?:object,
          product?:product,
          path?:string,
          
        ):product{

    let productNew = product;
    let genericType = false;
    
    let multi = productNew.multi;
    
    if ( val != null && typeof(val)=="string" || 
        this.hasRef(val) || 
        this.hasProp(this.hasRef(val)? obRef : val) || 
        this.hasEnum(this.hasRef(val)? obRef : val) ||
        this.hasType(this.hasRef(val)? obRef : val) ||
        this.hasRequired(this.hasRef(val)? obRef : val) ||
        this.hasAny(this.hasRef(val)? obRef : val)
        
      ){
      
      if ( this.hasRef(val)){
        let newVal:string = val['$ref'];
        newVal = newVal.replace("#/definitions/","");
        obRef = this.amazonSchema['definitions'][newVal];

        if ( newVal.includes('xsd:')){
          genericType = true;
        }
      }
      
      if ( this.hasProp( this.hasRef(val)? obRef : val) || this.hasAny(this.hasRef(val)? obRef : val) || this.hasRequired(obRef)){

        
          let deep:object = this.hasRef(val)? obRef['properties'] : val['properties'];
          
          let required = [];
          if ( this.hasRequired(obRef) ){
            required = obRef['required'];
          }

          if ( this.hasAny(this.hasRef(val)? obRef : val)){
              deep = this.hasRef(val)? obRef['anyOf'][0]['properties'] : val['anyOf'][0]['properties'];
              
              if ( deep == undefined && this.hasRef(val['anyOf'][0]) ){
                if ( this.hasRef(val['anyOf'][0])){
                  let newVal:string = val['anyOf'][0]['$ref'];
                  newVal = newVal.replace("#/definitions/","")
                  obRef = this.amazonSchema['definitions'][newVal];
  
                  if ( newVal.includes('xsd:')){
                    genericType = true;
                  }
  
                  deep = obRef['properties'];
                }
              }
          }
          
          Object.keys(deep).forEach(p=>{
              
              if ( p != "#"){
                if ( p != "$" ){
                  
                  let isattrib = p.startsWith('@') ? true : false;
                  
                  path = path + "/" + p
                  
                  
                  if ( this.colunNamePar == 'ProductData'){
                    if ( this.paths.filter(field => field.PATH == path || field.PATH.indexOf("/*")> 0 &&  path.startsWith(field.PATH.replace("/*",""))  ).length == 0){
                        path = path.replace('/'+p,'');
                        return product;
                    }
                    
                  }
                  
                  
                  let isRequired =  false;
                  
                  if ( required.indexOf(p) > -1 || this.mainRequired.indexOf(p)>-1 || SuperRequired.indexOf(p)>-1){
                      isRequired = true;
                  }


                  productNew = {
                    columnName: p,
                    child:[],
                    isattribute: isattrib,
                    isopen: false,
                    isvisible: true,
                    level: level,
                    required: false,//isRequired,
                    multi: multi
                 }

                 
                 
                }

                   
                productNew = this.getProp(level+1,productdata,
                                          deep[p] ,deep,productNew,path);
                

                
                if ( p != "$" ){
                    product.child.push(productNew);
                    path = path.replace('/'+p,'');
                }else{
                  return productNew;
                }
                
              }
              
          })
      }else{
          if ( genericType ){
            product.type = (val['$ref'] as String).replace("#/definitions/xsd:",'');
          }else{
            if ( this.hasEnum(this.hasRef(val)? obRef : val)){
              product.enum = this.hasRef(val)? obRef['enum'] : val['enum'];
            }
  
            if ( this.hasType(this.hasRef(val)? obRef : val)){
              product.type = this.hasRef(val)? obRef['type'] : val['type'];; 
            }

            if ( this.hasRef(val) ){
              if ( this.hasType(obRef)){
                product.type = obRef['type'];
              }
              if ( this.hasMinimum(obRef)){
                product.minLength = obRef['minLength'];
              }
              if ( this.hasMaximum(obRef)){
                product.maxLength = obRef['maxLength'];
              }
              
            }
  
          }

          
          return product;
      }
    }else{
      product.child.push(product);
      //return product;
    }
    
    return product;
  }


  findValuesHelper(obj, key, data) {
    let list = [ ];
    if (!obj) return list;
    if (obj instanceof Array) {
        for (var i in obj) {
            list = list.concat(this.findValuesHelper(obj[i], key,data));
        }
        return list;
    }
    if (obj[key]== data) list.push(obj);

    if ((typeof obj == "object") && (obj !== null)) {
        let children = Object.keys(obj);
        if (children.length > 0) {
            for (let i = 0; i < children.length; i++) {
                list = list.concat(this.findValuesHelper(obj[children[i]], key,data));
            }
        }
    }
    return list;
  }

  
  loadAmazonSchema(){
   return new Promise((resolve,reject)=>{
      this.http.getAsset(`assets/amazon-xsd/schema_amazon.json`).subscribe(data =>{
        this.amazonSchema  = JSON.parse(data);
        resolve('resolved')
        },error=>{
          reject(error)
        }
      )
    })
     
  }


  
  

  loadForm( formGroup:UntypedFormGroup, object:Object, path:string){

    if ( object != null && Object.keys(object).length> 0){
        Object.keys(formGroup.controls).forEach(key=>{
        
          let pathIn = path==''? key : path +"."+key;
          const form = formGroup.get(key);
          
          if ( form instanceof UntypedFormGroup){
            if ( Object.keys(form.controls).length > 0 ){
              this.loadForm(form,object,pathIn);
            }
          }else{  
            const ob = ObjectUtil.FindObjectAny(JSON.parse(object.toString()),pathIn);  
            form.setValue(ob);
          }
        
      });
    }

  }

  getMargin(item:product){
      
      switch (item.level){
        case 1 : return "20px";
        case 2 : return "30px";
        case 3 : return "40px";
        case 4 : return "50px";
        case 5 : return "60px";
        case 6 : return "70px";
        case 7 : return "80px";
        case 8 : return "90px";
        case 9 : return "100px";
        case 10 : return "110px";
        default : return "10px";
      }
        
        
  }


  getFormGroup(path):UntypedFormGroup{

    let valor:string[] = path.split(">");
    let i = 0;
    
    let formGroupTemp = this.formGroup1;
    for (var p of valor){
      if ( i > 0){
        
        if ( formGroupTemp.get(p) instanceof UntypedFormGroup){
          formGroupTemp  = formGroupTemp.get(p) as UntypedFormGroup 
        }
      }
      i++
    }

    return formGroupTemp;

  }
 

  find(event:KeyboardEvent){
    let finded:product[] =[];
    if ( event.key =='Enter'){
        this.findData(this.list,finded);
    }
    
  }
  
  findData(items:product[],finded:product[]){
      items.forEach(d=>{
          if ( d.child && d.child.length > 0 ){
            this.findData(items,finded);
          }else{
            if ( d.columnName.indexOf(this.searchValue) > -1){
              finded.push(d);
            }
          }
      });
  }
  
}
